import { http } from '../../axios';
import { shopPrefix } from '../../../config';
import { PromotionLinkResponse } from '../../../store/api';

const endpointPromotion = `${shopPrefix}/v1/marketing/campaigns/:campaignProductId/promotion`;

export function fetchPromotionData(campaignProductId: string) {
    return http
        .get<PromotionLinkResponse>(endpointPromotion, { pathParams: { campaignProductId } })
        .then(response => response.data);
}
